import { SvgNode } from "./SvgNode"
import "./ports/flowPort";
import "./ports/nozzlePort";
import "./ports/lineJumpPort";
import { UnitTagNode } from "./UnitTag"
import { NodeShapes } from "../services/modal"
import { TextNode } from "./TextNode"
import { ImageNode } from "./ImageNode"
import { SvgStream } from "./SvgStream"
import { LineJumpNode } from "./LineJump"

const svgNode = {
  shape: NodeShapes.SvgNode,
  width: 100,
  height: 100,
  component: SvgNode,
  effect: ['data', 'size']
};

const svgStream = {
  shape: NodeShapes.SvgStream,
  width: 120,
  height: 40,
  component: SvgStream,
  effect: ['data', 'size']
}

const unitTag = {
  shape: NodeShapes.UnitTag,
  width: 120,
  height: 40,
  resizable: false,
  component: UnitTagNode,
  effect: ['data', 'size']
}

const textNode = {
  shape: NodeShapes.TextNode,
  width: 120,
  height: 40,
  resizable: false,
  component: TextNode,
  effect: ['data', 'size']
}

const imageNode = {
  shape: NodeShapes.ImageNode,
  width: 120,
  height: 40,
  resizable: false,
  component: ImageNode,
  effect: ['data', 'size']
}

const lineJump = {
  shape: NodeShapes.LineJump,
  width: 120,
  height: 40,
  resizable: false,
  component: LineJumpNode,
  effect: ['data', 'size']
}

export const AllCustomCells = [svgNode, svgStream, unitTag, textNode, imageNode, lineJump]
